import * as Sentry from "@sentry/nextjs";

const vercelEnv = process.env.NEXT_PUBLIC_VERCEL_ENV; // "production" | "preview" | ""
const environment = vercelEnv === "production" ? "production" : vercelEnv === "preview" ? "staging" : "development";

Sentry.init({
  enabled: environment !== "development",
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment,
  release: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0,
  sendDefaultPii: false,
  ignoreErrors: [
    // ag-charts-community fires this on iOS during chart resize while a
    // tooltip is dismissing. Patched in 13.2.1, but keep as a guard so any
    // re-introduction stays out of Sentry. (XD-FRONTEND-7)
    /Failed to execute 'togglePopover'/,
    // Safari surfaces some aborted fetches/EventSources as bare CustomEvent
    // unhandledrejections with no stack. Pure noise, no user impact.
    // No anchors — Sentry tests this against several candidate strings
    // including "<type>: <value>", which would not match an anchored regex.
    // (XD-FRONTEND-E)
    /Event `CustomEvent` \(type=unhandledrejection\) captured as promise rejection/,
  ],
  beforeBreadcrumb(breadcrumb) {
    // Scrub kennitala patterns from breadcrumbs
    if (breadcrumb.message) {
      breadcrumb.message = breadcrumb.message.replace(
        /\b\d{6}-?\d{4}\b/g,
        "[KENNITALA]"
      );
    }
    if (breadcrumb.data?.url) {
      breadcrumb.data.url = breadcrumb.data.url.replace(
        /\b\d{6}-?\d{4}\b/g,
        "[KENNITALA]"
      );
    }
    return breadcrumb;
  },
});
